//BACKUP FOR LIVE SITE Jan 23 2025
import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import {
  SHOW_CALF, SIMPLE_VAL2, CHECK_TOKEN, SHOW_TOAST, FB_URL
} from '../store/actions/types'
import { showCalf } from '../store/actions/calfActions'
import { convertToken, getMyToken, createToken, getAdmin, checkToken } from '../store/actions/companyAdminActions'
import AddMyTokensDialog from '../components/Dialogs/AddMyTokensDialog'
//components/Dialogs/AddMyTokensDialog.js
import ReactPlayer from 'react-player'
import img1 from './eximg/img1a.jpg'
import img2 from './eximg/img2.jpg'
import img3 from './eximg/img3.jpg'
import * as qs from 'qs'
import GenTutorial from './PointsSurveys/GenTutorial'
import {
  isMobile,
  isBrowser
} from 'react-device-detect'
import { simpleValAction2 } from '../store/actions/simpleValAction2'
import { showToast } from '../store/actions/toastAction'
//import GetUserField from './GetPatron'
import firebase from '../store/firebase'
import { query, orderByChild, equalTo, get, ref } from "firebase/database";

import { initializeApp } from 'firebase/app';
import { getAuth, updateUser } from "firebase/auth";
import { signOut } from '../store/actions/authActions'
import PrevPage from './PrevPage'
import     './Sendmecoins.js';
import CryptoJS from 'crypto-js';
import moment from 'moment-timezone';
// import url from 'url'
// import patreonAPI, { oauth as patreonOAuth } from 'patreon'

class GotoGIFpledge extends React.Component {
  state = {
    code: null,
    calfmember: false,
    tokenData: null,
    success: true,
    openDialog: false,
    tokenRex: false,
    oauthGrantCode: false,
    NewWalletAddress: '',
    PrivateKey: '',
    coinsBought: 0,
    mevInWallet: '',
    walletAddress: '',
    mevCoinPriceInUSD: '',
    pledgeStart: null
  };

  constructor(props) {
    super(props)
   // this.confirmPledge = this.confirmPledge.bind(this);
   if ( this.props.rep===true ) {this.props.history.push('/gotoGIFpledge')} //correct url to use oauthGrantCodex

  //  var url1 = window.location.href;
  //  var urly = url1.substring(
  //    url1.indexOf("=") + 1, 
  //    url1.lastIndexOf("&")
  //  );
  //   if (urly===false) {
     
  //   } else {
  //    if ( this.props.rep===true ) {this.props.history.push('/gotopatreon')} 
  //   }

    // this.sendGetRequest(this.props.calfemail, this.props, '2') //set onething = true if on calf databse
  }

  askPermission = () => {
    const { tokenRequested} = this.props
    // this.props.loadingAction({
    //   leaderboard_loading: 1,
    //   type: LEADERBOARD_LOADING
    // })
    const promise = this.getPermission()
    promise.then(this.onFulfilled, this.onRejected)
  }

  handleCloseDialog = () => {
    
    this.setState({ openDialog: !this.state.openDialog })
  };

///////////////////////////////////////////
getOwnerProps(props, typ) {
   
  for (let x in props) {
    switch(typ) {
      case 'email':
        return props[x].email
        break;
      case 'firstName':
        return props[x].firstName
        break;
      case 'lastName':
        return props[x].lastName
        break;
      case 'companyID':
        return props[x].companyID
        break;
      case 'userID':
        return props[x].userID
        break;
      default:
        // code block
    }
  }
}

loadTokenA = (params, data) => {
  // if (this.props.adminAcc) {
   const promise = this.loadTokenB(params, data)
   promise.then(this.onFulfilled, this.onRejected)
 // } 
}

loadTokenB = (params, data) => {
  const { createToken } = this.props
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (this.state.success) {
        let data = {
          email: this.getOwnerProps(this.props.adminAcc, 'email'),
          firstName: this.getOwnerProps(this.props.adminAcc, 'firstName'),
          lastName: this.getOwnerProps(this.props.adminAcc, 'lastName'),
          companyID: this.getOwnerProps(this.props.adminAcc, 'companyID'),
          userID: this.getOwnerProps(this.props.adminAcc, 'userID'),
    
          personID: this.props.userdata.userID, //token sent to
          personName: this.props.userdata.firstName,
          personLastName: this.props.userdata.lastName,
          personEmail: this.props.userdata.email,
          tokenType: params.tokenType,
         // amount: this.props.amount
        } 
          
         if (data.email) {
          createToken(data);
          } 
         else
         {
          }
      } else {
        reject('Failed to the user list')
      }
    }, 10000)
  })
}

  handleSubmitUser = async usersData => {
    const { getAdmin, userdata } = this.props
     let data = {companyID: userdata.companyID}
     this.setState({tokenRex: true})

     let paramsX = {
      type: SHOW_TOAST,
      open: true,
      variant: 'success',
      message: 'Your Token has been Requested. Please wait a moment.'
    }

    this.props.showToast(paramsX)

     await getAdmin(data);

    let params={
      tokenType: usersData.tokenType
    }
    this.loadTokenA(params, data)

       // this.handleCloseDialog()
  };

  getPermission = () => {
    const { convertToken, onething, simpleValAction2, getMyToken, mytoken, tokenRequested } = this.props
    var tokentext
    var tok;

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (this.state.success) {
          // if (this.state.calfmember === true && this.props.userdata.from !== 'StrategyX') { // FIRST TIME GOING THROUGH
         // && this.props.userdata.from !=='StrategyX'
             if (this.props.mytoken && tokenRequested === 'yes' && this.props.onething === true ) { // FIRST TIME GOING THROUGH means user is on calf database
            //token requested and payment already made
            //CALF PRODUCTS MODIFY HERE
            if (this.props.mytoken.tokenType === 'app') { tokentext = 'ThinkLead app' }
            if (this.props.mytoken.tokenType === 'ex1') { tokentext = 'Executive Club 1' }
            if (this.props.mytoken.tokenType === 'ex2') { tokentext = 'Executive Club 2' }

            tok = this.props.mytoken.token

            // const answerToken = prompt(
            //   'Please provide a Token to join the Executive Club.'
            //   + ' You have purchased the ' + tokentext + '. ' + 
            //   'Here is your token: ' + tok + '', tok
            // )
            answerToken = 'yes'
           // if (answerToken === '' || answerToken === null || answerToken === 'no') {
           // } else {
              
              this.sendGetRequest(this.props.calfemail, this.props, '3') //set execmember=true & open EC
              let val = {
                token: answerToken,
                userID: this.props.userdata.userID
              }
              convertToken(val)  // CONVERT TOKEN TO CREDIT
           // }
          }
          else {

            
          }
        } 
        else {
          reject('Failed to the user list')
        }
      }, 6000)
    })
  }

  findTokenA = () => {
    
    const promise = this.findTokenB()
    promise.then(this.onFulfilled, this.onRejected)
  }
  
  findTokenB = () => {
    const { tokenRequested } = this.props
   
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (this.state.success) {
          
        
          if (tokenRequested==='no' || tokenRequested===undefined) {
            this.setState({openDialog: true})
           }
        } else {
          reject('Failed to the user list')
        }
      }, 6000)
    })
  }
//////////////////////////////////////////////////////////////////////////////////////////

  getSubstring(string, char1, char2) {
    return string.slice(
      string.indexOf(char1) + 1,
      string.lastIndexOf(char2),
    );
  }
  
  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
  charactersLength));
    }
    return result;
  }

  encryptPrivateKey = (privateKey) => {
    const passphrase = "Lead54321";
    // Convert the private key to a WordArray (binary format)
    const wordArray = CryptoJS.enc.Hex.parse(privateKey.slice(2)); // Remove the "0x" prefix
    return CryptoJS.AES.encrypt(wordArray, passphrase).toString();
  }
  
  decryptPrivateKey = (encryptedKey) => {
    const passphrase = "Lead54321";
    
  
    try {
      // Decrypt the encrypted key
      const bytes = CryptoJS.AES.decrypt(encryptedKey, passphrase);
      // Convert the decrypted WordArray back to a hex string
      const decryptedHex = CryptoJS.enc.Hex.stringify(bytes);
  
      if (!decryptedHex) {
        console.log("Decryption failed. The resulting string is empty.");
      }
  
      // Add back the "0x" prefix to match the original format
      const decrypted = `0x${decryptedHex}`;
  
      
      return decrypted;
    } catch (_) {
      
      return null; // or handle the error as needed
    }
  };  

  checkAndUpdatePledgeStart = async (uid) => {
    const userRef = firebase.database.ref('user/' + uid);
    var updates = {};
      //const db = getDatabase();
      //const userRef = ref(db, `user/${uid}`);
      
      try {
        //const snapshot = await get(userRef);
        const snapshot = await userRef.once('value');

        
        // const snapshot = await userRef.once('value');
        if (!snapshot.exists()) {
          
          return false;
        }
        

        const userData = snapshot.val();
        const pledgeStart = Number(userData.pledgeStart) || 0; // Ensure it's a number
        const now = Date.now();
        
        
        
        

        
        
        
        let minSinceStart;
    
        if (pledgeStart) {
          minSinceStart = Math.floor((now - pledgeStart) / (1000 * 60)); // Round down to the nearest whole minute
        } else {
          minSinceStart = 20; // Default to 20 minutes if pledgeStart is missing
        }
    
        
    
        if (minSinceStart < 5) {
          return false;
        }
       
          updates['/user/' + uid + '/pledgeStart'] = now;
          await firebase.database.ref().update(updates);
          return true;
       
       // await update(userRef, { pledgeStart: now });
       // await firebase.database.ref().update(updates);
        

        return true;
      } catch (_) {
        
        return false;
      }
    };

  async getPledgePercentage(pledge, pemail) {
    // Define the email list
    //'James@theritchiegroup.com',
    //'alhajmelamu@gmail.com',
    const emailList = [
      'Ivan@lowveldservice.co.za',
      'Louise@symphonia.net',
      'johanhippo1508@gmail.com',
      'zjhardware2010@gmail.com',
      'martin@martincrous.com',
    ];
  
    // Check if pemail is in the email list (case-insensitive for robustness)
    if (emailList.some(email => email.toLowerCase() === pemail.toLowerCase())) {
      return [pledge * 0.50, pledge * 0.25];
    } else {
      if (pledge < 395) return [0, 0];
      return [pledge * 0.25, pledge * 0.25];
    }
  }

async addMIF(email, pointsAdd, dolive) {
  var updates = {};
  var pointsSnapshot;
  var uid;
  var userID;
  var userData;
  var ress;

    const db = firebase.database;
    const usersRef = db.ref("user");
    const emailQuery = query(usersRef, orderByChild("email"), equalTo(email));

    try { //get uid and points
        const snapshot = await get(emailQuery);
        
        if (snapshot.exists()) {
            // Get the first user with the matching email
            
            userData = snapshot.val();
            uid = Object.keys(userData)[0]; // Get the first matching UID
            
            // Fetch points
             pointsSnapshot = await get(ref(db, `user/${uid}/points`));
              
           // return pointsSnapshot.exists() ? pointsSnapshot.val() : null;
        } else {
            
           // return null;
        }
    } catch (_) {
        console.log('Flexpledge err in addMIF 1: ');
       // return null;
    }

    const usersRefB = db.ref("users");
    const emailQueryB = query(usersRefB, orderByChild("email"), equalTo(email));
    
    try {
      const snapshotB = await get(emailQueryB);
      
      if (snapshotB.exists()) {
        
          // Get the first user with the matching email
          const userDataB = snapshotB.val();
          userID = Object.keys(userDataB)[0]; // Get the first matching UID
          
      } else {
          
         // return null;
      }
  } catch (_) {
      console.log('Flexpledge err in addMIF 2: ');
     // return null;
  }

 // const points = Number(pointsSnapshot) + Number(pointsAdd);
  const points = Number(pointsSnapshot.val() || 0) + Number(pointsAdd);

   updates['/users/' + userID + '/points'] = points;
   updates['/user/' + uid + '/points'] = points;

   console.log('Flexpledge addMIF: ', updates);
  ////////////////////////////////////////////////////////////////////////
  if (dolive===true) {
        ress = await axios.post(`${FB_URL}/m115-freshcard`, {
            params: {
                updates: updates, //user wallet address                       
            }
          })
  
        if (ress.data || ress.data.success === true) {
          console.log('Successfully updated addMIF in Flex pledge');
        }
        else {
          console.log('Error updating addMIF in Flex pledge comp');
        }; 

    // firebase.database.ref().update(
    //   updates,
    //   function (error) {
    //     if (error) {
          
    //     } else {
          
    //     }
    //   }
    // );   
   }   
    }

   ///////////////////////////////////////////////////////////////////////////////////////////
   //new code for only mychristo@gmail.com to confirm ALL pledges
   ///////////////////////////////////////////////////////////////////////////////////////////
   getUserDataByEmail_simple = async (email) => {
      try {
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
        const emailQuery = query(usersRef, orderByChild('email'), equalTo(email));
    
        // Get user data
        const snapshot = await get(emailQuery);
    
        if (snapshot.exists()) {
          // Get the first user with the matching email
          const userData = Object.values(snapshot.val())[0];
    
          // Construct the response object with required fields
          const userInfo = {
            uid: userData.uid,
            userID: userData.userID,
            userWalletAddress: userData.wallet,
            companyID: userData.companyID,
            lastPay: userData.payoutdate,
            profileName: userData.userType,
            profile: userData.userDescription,
            companyName: userData.companyName,
            firstName: userData.firstName,
            lastName: userData.lastName,
            isPatron: userData.patron,
            patronPoints: userData.points,

          };
    
          return userInfo;
        } else {
          // Return null or throw error if user not found
          console.log('User not found');
        }
      } catch (_) {
        
        console.log('getUserDataByEmail_simple error: ');
      }
   };

    getUserDataByEmail = async (email) => {
      try {
        // Normalize email input (lowercase and trim)
        const normalizedEmail = email.toLowerCase().trim();
        const originalEmail = email.trim(); // Preserve original case
        // Capitalize first letter of email (e.g., louise@symphonia.net -> Louise@symphonia.net)
        const capitalizedEmail = normalizedEmail.replace(/^./, str => str.toUpperCase());
        
    
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
    
        // Helper function to query users by email
        const queryUsers = async (queryEmail) => {
          const emailQuery = query(usersRef, orderByChild('email'), equalTo(queryEmail));
          const snapshot = await get(emailQuery);
          
          return snapshot;
        };
    
        // Try normalized email first
        let snapshot = await queryUsers(normalizedEmail);
    
        // If no results, try original email case
        if (!snapshot.exists() && normalizedEmail !== originalEmail) {
          
          snapshot = await queryUsers(originalEmail);
        }
    
        // If no results, try capitalized email
        if (!snapshot.exists() && normalizedEmail !== capitalizedEmail) {
          
          snapshot = await queryUsers(capitalizedEmail);
        }
    
        if (snapshot.exists()) {
          // Get all matching users and their keys (UIDs)
          const users = Object.values(snapshot.val());
          const userKeys = Object.keys(snapshot.val());
    
          // Log all matching users for debugging
          
    
          // Map all users with payoutdate for sorting
          const userRecords = users.map((user, index) => ({
            data: user,
            uid: userKeys[index],
            payoutdate: user.payoutdate ? new Date(user.payoutdate).getTime() : 0,
          }));
    
          // Filter users where patron field exists
          let selectedUsers = userRecords.filter((user) => user.data.patron !== undefined);
    
          if (selectedUsers.length === 0) {
            
            // Fallback to all users if no patron field exists
            selectedUsers = userRecords;
          }
    
          if (selectedUsers.length === 0) {
            
            console.log('No valid user data found');
          }
    
          // Sort by payoutdate (descending: newest first), then UID
          selectedUsers.sort((a, b) => {
            if (a.payoutdate && b.payoutdate) {
              return b.payoutdate - a.payoutdate; // Newest payoutdate first
            }
            return b.uid.localeCompare(a.uid); // Newest UID first
          });
    
          // Log sorted records
          
    
          // Select the newest
          const selectedUser = selectedUsers[0].data;
          const selectedKey = selectedUsers[0].uid;
    
          // Construct the response object
          const userInfo = {
            uid: selectedUser.uid || selectedKey,
            userID: selectedUser.userID || null,
            userWalletAddress: selectedUser.wallet || null,
            companyID: selectedUser.companyID || null,
            lastPay: selectedUser.payoutdate || null,
            profileName: selectedUser.userType || null,
            profile: selectedUser.userDescription || null,
            companyName: selectedUser.companyName || null,
            firstName: selectedUser.firstName || null,
            lastName: selectedUser.lastName || null,
            isPatron: selectedUser.patron || false,
            patronPoints: Number(selectedUser.points) || 0,
          };
    
          // Validate required fields
          if (!userInfo.uid || !userInfo.userID) {
            
             console.log(`Invalid user data for email ${normalizedEmail}`);
          }
    
          
          return userInfo;
        } else {
          
          console.log('User not found');
        }
      } catch (_) {
        
       // throw error;
      }
    };

   async componentDidMount() {
      await this.confirmPledge();
   }

   confirmPledge = async () => {
    var uid;
    var uidA;
    var userID;
    var userIDA;
    var userEmail;
    var userEmail_trim;
    var emailT;
    var emailA = [];
    var emailB = [];
    var companyID;
    var doUpdates = false;
    var userwalletaddress;
    var skipUser = false;
    var len;
    var pledge;
    var pledgepers;
    var i = 0;
    var trans = false;
    var companyName;
    var firstName;
    var lastName;
    var updates = {};
    var GIF_pool = 0;
    var ress;

    //////////////////
    var dolive = false;
    //////////////////
    console.log('Pledge names start: ', dolive);

    // const adminAccA = 'adriaan@leadershipplatform.com';
    // const adminAccC = 'mychristo@gmail.com';
    // const adminEmails = [adminAccA, adminAccC];

    const adminAccA = 'adriaan@leadershipplatform.com';
    const adminAccC = 'mychristo@gmail.com';
    const adminAccE = 'kriskraai127@gmail.com';

    const adminEmails = [adminAccA, adminAccC, adminAccE];

    if (!adminEmails.includes(this.props.userdata.email.toLowerCase())) {
    console.log('Unauthorized: Only admin account can access this function');
    return;
    }

    pledge = localStorage.getItem('lcAmount'); 
    userEmail_trim = localStorage.getItem('targetEmail'); 
    pledgepers = localStorage.getItem('pledgepers'); 

    console.log('GIF pledge pledge: ', pledge);
   // console.log('Pledge names userEmail_trim: ', userEmail_trim);
   // console.log('Pledge names pledgepers: ', pledgepers);

       if (window.location.href==='http://localhost:3000/gotoGIFpledge') {
        console.log('Pledge names 1: ');
          try {

            let patronData;
            try {
              patronData = await this.getUserDataByEmail(userEmail_trim);
               // Should log the resolved userInfo object

              // Assign values to existing variables
         
            uid = patronData.uid;
            userID = patronData.userID;
            var userWalletAddress = patronData.userWalletAddress;
            companyID = patronData.companyID;
            var lastPay = patronData.lastPay;//payoutdate
            var profile_n = patronData.profileName;
            var profile = patronData.profile; //userDescryption
            var isPatron = patronData.isPatron;
            var points = patronData.patronPoints;
            companyName = patronData.companyName;
            firstName = patronData.firstName;
            lastName = patronData.lastName;

            console.log('Pledge names 2: ', userID);

            const pledgeStart = true;

            if (pledgeStart===false) {
            //  return;
            }   

            
         } catch (_) {
              console.log('confirmPledge error: ');
          }
               doUpdates = true;   
              
               if (doUpdates) {
                 var newPay;
                 var dateA;
                 var dateB;
                 var newPayBool;
                 var timeNow;
                 var plev;
                 var pledge_pers_pool;
                 var newWallet = false;
                 var walletAddress;
                 var privateKey;
                 var mevInWallet;
                 var totalGasFeesInUSD;
                 var Malik;
                 var thinkLead;
                 var MRFA;
                 var MRFC;

                 var Pa;
                 var Ma;
                 var El;
                 var Jan;
                 var Ad;
                 var Chr;
                 var Richie;
                 var AdrTOT;
                 var ChrTOT;
                       
                 timeNow = new Date();
                         
          if (pledge > 400) { //must be true
            console.log('Pledge names points: ', points);
    
            const pemail = userEmail_trim;
    
            var pledge_pers = pledge * pledgepers;

            console.log('Pledge names pledge_pers: ', pledge_pers);
            console.log('Flexpledge amount: ', pledge);

            //12% - Thinklead
           // thinkLead = pledge * 0.12; //12% for thinklead
            thinkLead = pledge * (0.12 - 0.000909091);
            //25% - patron coins
            //pledge_pers = pledge_pers; //25% for patron coins
            //25% - GIF
              //pledge_pers_pool
            //25% - GIF/LIQ/PIF
            //liq = liq;
            //7%  - MRFA
            //MRFA = pledge * 0.07;
            MRFA = pledge * (0.07 - 0.003181818);
            //2%  - MRFC
            //MRFC = pledge * 0.02;
            MRFC = pledge * (0.02 - 0.000909091);
            //3%  - FIF
            //--------------------
            Pa = pledge * 0.01;
            Ma = pledge * 0.002;
            El = pledge * 0.005;
            Jan = pledge * 0.003;
            
            Ad = pledge * 0.005;
            Chr = pledge * 0.005;
            
            //1%  - Malik 
            Malik = pledge * 0.01;
            //MIF/////////////////
            Richie = pledge * 0.005;
            ///////////////////////
            AdrTOT = MRFA + Ad;
            ChrTOT = MRFC + Chr;
            //////////////////////////////////////////////////////////////////////
            //12% - Thinklead
            //25% - patron coins
            //25% - GIF
            //25% - GIF/LIQ/PIF
            //7%  - MRFA
            //2%  - MRFC
            //3%  - FIF
            //  Pa    - 1
            //  Ma    - 0.2
            //  el    - 0.5
            //  Jan   - 0.3
            //  Ad    - 0.5
            //  Chris - 0.5
            //Malik = pledge * 0.01; //Malik 1% of whole pledge

            

            ///MIF////////////////////////////////////////////////////////
             //await this.addMIF('adriaan@leadershipplatform.com', MRFA, dolive);//MEV updates
             //await this.addMIF('mychristo@gmail.com', MRFC, dolive);

            console.log('Pledge names 4: ', userID);

             await this.addMIF('louis@leadershipplatform.com', Pa, dolive);
             await this.addMIF('rinagroen6@gmail.com', Ma, dolive);
             await this.addMIF('elmarie227@gmail.com', El, dolive);
             await this.addMIF('tinselslipperedfeet@gmail.com', Jan, dolive);
             await this.addMIF('adriaan@leadershipplatform.com', AdrTOT, dolive);
             await this.addMIF('mychristo@gmail.com', ChrTOT, dolive);

             console.log('Pledge names 5: ', ChrTOT);
            /////////////////////////////////////////////////////////////
             await this.addMIF('alhajmelamu@gmail.com', Malik, dolive);           
            //MIF//////////////////////////////////////////////////////////////
              await this.addMIF('r.tyler.ritchie@gmail.com', Richie, dolive);
            //work out what goes for GIF
            //pledge_pers_pool = Number(pledge) - Number(pledge_pers) - Number(thinkLead) - Number(MRFA) - Number(MRFC) - Number(Pa) - Number(Ma) - Number(El) - Number(Jan) - Number(Ad) - Number(Chr) - Number(Malik) - Number(Richie);// - Number(liq) ;                 
            pledge_pers_pool = Number(pledge) - Number(thinkLead) - Number(MRFA) - Number(MRFC) - Number(Pa) - Number(Ma) - Number(El) - Number(Jan) - Number(Ad) - Number(Chr) - Number(Malik) - Number(Richie);// - Number(liq) ;                 
           
            GIF_pool = pledge_pers_pool;
    
             await new Promise(resolve => setTimeout(resolve, 3000));

               var newPoints = Number(points) +  Number(pledge_pers);
              /////////////////////////////////////////////////////////////////////////
              const getPatData = {
                profile_n: profile_n,
                profile: profile,
                pledge: pledge,
                newPay: newPay,
                points: newPoints,
                pledge_pers: pledge_pers,
                userPoints: points,
                userEmail_trim: userEmail_trim
               }
             var trailID = this.makeid(10)
             var MEVID = this.makeid(10);
             var now = new Date();
             var isoString = now.toISOString();
       
              // const timeNowx = `${year}-${month}-${day} ${hours}:${minutes}`;
              const timeRaw = moment().tz('Africa/Johannesburg');        
              const timeNowx = timeRaw.format('YYYY-MM-DD HH:mm');              
              ///////////////////////////////////////////////////////////////////////////   
              //updates['/users/' + userID + '/points'] = newPoints;  
              //updates['/user/' + uid + '/points'] = newPoints;
              ////////////////////////////////////////////////////////////////////////////////////
              const pts = (Number(pledge_pers) / 100);
              const ptsA = pts.toString() 
              const ptsB = ptsA + ' Lc'
    
              const Gpts = Number(pledge_pers_pool) / 100; //GIF

               updates['/pointsTrail/' + trailID] = {
                userID: userID,
                fdate: timeNowx,//timeNow,
                trailID: trailID,
                companyName: companyName,
                firstName: firstName,
                lastName: lastName,
                title: 'GIF Pledge converted',
                //actionType: pts ? ptsA + ' GIF from Pledge': 'Pledge not converted to LC',
                //actionDesc: pts ? ptsA + ' GIF from Pledge': 'Pledge not converted to LC',
                actionType: 'GIF Pledge confirmed',
                actionDesc: 'GIF Pledge confirmed',
                pointsAdded: ptsB,
                pointsCurrent: newPoints,
                gas: 0
               }
 
              updates['/MEVDATA/' + trailID] = {
                userID: userID,
                fdate: timeNowx,//timeNow,
                trailID: trailID,
                companyName: companyName,
                firstName: firstName,
                lastName: lastName,
                title: 'GIF Pledge confirmed',
               // actionDesc: pts ? ptsA + ' GIF Pledge': 'Pledge not converted to LC',
                actionType: 'GIF Pledge confirmed',
                actionDesc: 'GIF Pledge confirmed',
                pointsAdded: Gpts,
                pointsCurrent: 0,
                gas: 0
               }

              ///////////////////////////////////////////////////////////////////////
            if (dolive===true) {
                ress = await axios.post(`${FB_URL}/m115-freshcard`, {
                   params: {
                        updates: updates, //user wallet address                       
                    }
                  })

              if (ress.data || ress.data.success === true) {
                console.log('Successfully updated pledge');
               // console.log('Flexpledge names true: ', firstName + ' ' + lastName + ' ' + userEmail_trim);
              }
              else {
                console.log('Error updating Flex Pledge:');
              };        
               /////
             }
              console.log('GIFpledge updates: ', updates);
             // console.log('GIFpledge test: ', firstName + ' ' + lastName + ' ' + userEmail_trim);

             // 115743.5 - Aug 4 2025 GIF Malik: 
              updates = {};
              // //////UPDATE GIF LCPOOL////////////////////////////////////////////////////
                
          if (dolive===true) {
           //////////////////////////////////////////////////////////////////////////// 
            console.log('GIF Pledge start 1');          
           await axios.post(
                'https://us-central1-leadershipplatform-158316.cloudfunctions.net/m117-addToLCPool',
                {
                  params: { amount: pledge_pers_pool }   // ← keep your old structure
                }
              );     
              console.log('GIF Pledge start 2', pledge_pers_pool);  

              if (ress.data || ress.data.success === true) {
                console.log('GIF Pledge Successfully updated pledge');
                console.log('GIF Pledge Pledge log names true: ', firstName + ' ' + lastName + ' ' + userEmail_trim);
              }
              else {
                console.log('GIF Pledge Error in confriming pledge');
              };
           }

              await new Promise(resolve => setTimeout(resolve, 3000));
            /////////////////////////////////////////////////////////////////
              }
               }
              
       } catch (_) {
            console.log('GIF Pledge Error in confriming pledge:');
            } 

      } 
  }

  handlePatreonAuth = () => {
      
    const REDIRECT_URI = 'http://localhost:3000/gotoGIFpledge'; 
    const CLIENT_ID = 'ec6tZpjG-eZ03I8zczklRVnUmCbDfxcZAs3-FRWhTPamHrFP5hNuYFiQiI9Ra6Gp';

    window.location.href = `https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`;
  };

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.location !== prevProps.location) {
      const oauthGrantCode = this.getOAuthcodeB();
      if (oauthGrantCode) {
          
        //this.setState({oauthGrantCode: true})
        try {
          await axios
          .post(`${FB_URL}/m105-getpatreon`, {params: { 
             code: oauthGrantCode, 
             n: '111', 
             inc: '777' 
            } })
          .then(res => {
                 
              // Set a flag to indicate that Patreon authorization is done
              localStorage.setItem('patreonAuthorizationDone', 'true');
          })
         }
          catch(err) {
            }
      } else {
        
      }
    }
  }

  getOAuthcodeB = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('code');
  };

//////////////////////////////////////////////////////////////////////////////////////////

  handleOpen = url => {
    window.open(url, '_blank')
  };



  preSubmit = () => {
   // const { onSubmitUserClick} = this.props
   // this.setState({ lockButton: true })

  //  <MenuItem key={'app'} value={'app'} >
  //  {'Executive Club Ownership $85/month'}
  //  <MenuItem key={'ex1'} value={'ex1'} >
  //  {'Executive Club Membership 1: $28/month'}
  //  <MenuItem key={'ex2'} value={'ex2'} >

    this.handleSubmitUser({
          tokenType:this.state.tokenType,
          amount: this.state.amount
      });

   }

  render() {
    const { calf } = this.props
     
    if (this.props.userdata.execmember === false) { // NOT SUBSCRIBED

      return (
                <React.Fragment>
                  <div style={{
                    display: 'block',
                    // marginLeft: isMobile ? "10px" : "0px",
                    backgroundColor: '#FFFBE6',
                    color: '#695800',
                    padding: '20px',
                    width: isMobile ? '100%' : '80%',
                    size: '16px',
                  }}>
                        <h3>Me Vision</h3>
                        <p style={{ textAlign: "justify", display: "block" }}><a style={{ fontSize: "1.5em", fontWeight: "strong" }}>ME-Vision Academy</a> is about a journey to Authentic Self-Confidence, 
                            SUPER PLEDGE.</p>
    

                  </div>
                </React.Fragment>

      )
    }
    else { //SUBSCRIBED YES

      return (
        <React.Fragment>
        <div style={{
          display: 'block',
          // marginLeft: isMobile ? "10px" : "0px",
          backgroundColor: '#FFFBE6',
          color: '#695800',
          padding: '20px',
          width: isMobile ? '100%' : '80%',
          size: '16px',
        }}>
              <h3>Me Vision</h3>
              <p style={{ textAlign: "justify", display: "block" }}><a style={{ fontSize: "1.5em", fontWeight: "strong" }}>ME-Vision Academy</a> is about a journey to Authentic Self-Confidence, 
                  SUPER PLEDGE</p>

        </div>
      </React.Fragment>

      )
    }
  }
}

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    calf: state.calf.calf,
    onething: state.oneVal2.sVal2,
    mytoken: state.mainToken.mtoken,
    adminAcc: state.mainToken.oadmin,
    tokenRequested: state.hasToken.hasToken
    // onething: state.sVal
    // simplething: state.simpleVal.simplething
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showCalf: params => dispatch(showCalf(params)),
    getMyToken: params => dispatch(getMyToken(params)),
    convertToken: params => dispatch(convertToken(params)),
    createToken: params => dispatch(createToken(params)),
    simpleValAction2: params => dispatch(simpleValAction2(params)),
    getAdmin: params => dispatch(getAdmin(params)),
    checkToken: params => dispatch(checkToken(params)),
    showToast: params => dispatch(showToast(params)),
    signOut: () => dispatch(signOut())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GotoGIFpledge)
